<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        View Options
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-6">
                            <button @click="expandAll" type="button" class="btn btn-light w-100">
                                <i class="far fa-expand-alt"></i>
                                Expand Epics
                            </button>
                        </div>
                        <div class="col-6">
                            <button @click="collapseAll" type="button" class="btn btn-light w-100">
                                <i class="far fa-compress-alt"></i>
                                Collapse Epics
                            </button>
                        </div>
                    </div><!-- /.row -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,


        data() {
            return {
            }
        },

        methods: {
          expandAll() {
            var epicGroups = document.querySelectorAll(".container-project-board .epic > .collapse")
            var epics = document.querySelectorAll(".container-project-board .pb-epic-heading")

            epicGroups.forEach((epicGroup) => {
              epicGroup.classList.add('show')
            })

            epics.forEach((epic) => {
              epic.classList.remove('collapsed')
            })

          },

          collapseAll() {
            var epicGroups = document.querySelectorAll(".container-project-board .epic > .collapse")
            var epics = document.querySelectorAll(".container-project-board .pb-epic-heading")

            epicGroups.forEach((epicGroup) => {
              epicGroup.classList.remove('show')
            })

            epics.forEach((epic) => {
              epic.classList.add('collapsed')
            })
          }
        }
    }
</script>
